export const priorityMap = {
  1: {
    label: "High",
    color: "danger",
  },
  2: {
    label: "Medium",
    color: "warning",
  },
  3: {
    label: "Low",
    color: "success",
  },
};

/** List/overview label from nested `sourceChannel`. */
export function formatSourceChannelLabel(
  channel?: { name?: string; code?: string } | null,
): string {
  const label = channel?.name?.trim() || channel?.code?.trim();
  return label || "—";
}
